import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DragDropService } from '@app/core/services/drag-drop.service';
import { Store } from '@ngxs/store';
import { combineLatest, filter, Observable, Subscription } from 'rxjs';
import { AppConfig } from '../../models/app-config.model';
import { PodcastTabModel } from '../../models/app-tabs.model';
import { UpdateAppConfig } from '../../states/app-configuration.actions';
import { AppConfigurationState } from '../../states/app-configuration.state';

@Component({
  selector: 'rk-podcast-configuration',
  standalone: false,
  templateUrl: './podcast-configuration.component.html',
  styleUrl: './podcast-configuration.component.scss',
})
export class PodcastConfigurationComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly dragDropService = inject(DragDropService);
  private readonly subscriptions = new Subscription();

  currentAppConfig$: Observable<AppConfig> = this.store.select(
    AppConfigurationState.currentAppConfig,
  );
  pageIndex$: Observable<number> = this.store.select(
    AppConfigurationState.activePageIndex,
  );

  podcastFeedUrls: string[];

  ngOnInit(): void {
    this.subscriptions.add(
      combineLatest([this.currentAppConfig$, this.pageIndex$])
        .pipe(filter(([config, pageIndex]) => !!config && pageIndex !== null && !isNaN(pageIndex)))
        .subscribe(([config, pageIndex]) => {
          const podcastPageContent = config.onglets[pageIndex] as PodcastTabModel;
          this.podcastFeedUrls = podcastPageContent?.podcastsRssList;
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  dragStart(): void {
    this.dragDropService.startDragging();
  }

  drop(event: CdkDragDrop<string[]>): void {
    // reorder the local array
    const updatedPodcastUrls = [...this.podcastFeedUrls];
    moveItemInArray(updatedPodcastUrls, event.previousIndex, event.currentIndex);

    // update the local array for immediate UI feedback
    this.podcastFeedUrls = updatedPodcastUrls;

    // stop dragging state
    this.dragDropService.stopDragging();

    const pageIndex = this.store.selectSnapshot(AppConfigurationState.activePageIndex);
    if (!isNaN(pageIndex) && pageIndex !== null) {
      this.store.dispatch(
        new UpdateAppConfig(
          ['onglets', pageIndex.toString(), 'podcastsRssList'],
          this.podcastFeedUrls,
        ),
      );
    }
  }
}
